import { render, staticRenderFns } from "./Co2Calculator.vue?vue&type=template&id=303c99af&"
import script from "./Co2Calculator.vue?vue&type=script&lang=js&"
export * from "./Co2Calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/elektron/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('303c99af')) {
      api.createRecord('303c99af', component.options)
    } else {
      api.reload('303c99af', component.options)
    }
    module.hot.accept("./Co2Calculator.vue?vue&type=template&id=303c99af&", function () {
      api.rerender('303c99af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/elektron/js/components/Co2Calculator.vue"
export default component.exports